import { render, staticRenderFns } from "./PaiementError.vue?vue&type=template&id=11656cd1&scoped=true"
import script from "./PaiementError.vue?vue&type=script&lang=js"
export * from "./PaiementError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11656cd1",
  null
  
)

export default component.exports